import { colors, throttle } from '../../common/utils';

import els from './elements';

let activeTab = null;

const defaultTab = 'map';

const parseHashRoute = (path) => {

    const parts = (
        path
            .replaceAll('#', '')
            .split('/')
            .filter((part) => part.length > 0)
    );

    return {
        tab: parts[0] ?? null,
        state: parts[1] ?? null,
    };
};

const positionTabIndicator = (animate = true) => {

    const $tabbed = els.$tabbed();

    const $toggle = els.$toggle($tabbed);
    const $indicator = els.$indicator($tabbed);
    const $activeOption = els.$option($tabbed, activeTab);

    $indicator.css({
        transition: animate ? '' : 'none',
        width: `${$activeOption.outerWidth()}px`,
        left: (
            activeTab == 'map'
                ? 0
                : $toggle.width() - $activeOption.outerWidth()
        ),
    });
};

const setActiveTab = (tab, animate = true) => {

    activeTab = tab;

    const $tabbed = els.$tabbed();

    const $options = els.$options($tabbed);
    const $activeOption = els.$option($tabbed, activeTab);
    const $inactiveOption = $options.not($activeOption);

    const $tabs = els.$tabs();
    const $activeTab = els.$tab($tabs, activeTab);
    const $inactiveTab = $tabs.not($activeTab);

    positionTabIndicator(animate);

    $activeOption.css({ color: colors.white });
    $inactiveOption.css({ color: '' });

    $inactiveTab.hide();
    $activeTab.show();
};

const initializeTabs = () => {

    const $tabbed = els.$tabbed();
    const $toggle = els.$toggle($tabbed);
    const $options = els.$options($tabbed);

    const { tab, state } = parseHashRoute(window.location.hash);

    setActiveTab(tab ?? defaultTab, false);

    let onComplete = () => {};

    if (state !== null) {

        onComplete = () => {
            const { propertiesMap } = window.vues;
            propertiesMap.setSelectedState(state);
        };
    }

    if (tab !== null) {

        $tabbed.scrollIntoView({
            accountForHeader: false,
            alignment: 'center',
            onComplete,
        });
    }

    $options.on('click', async (event) => {

        event.preventDefault();

        const path = $(event.currentTarget).attr('href');
        const { tab } = parseHashRoute(path);

        if (tab === 'grid') {
            await window.vues.propertiesMap.setSelectedCity(null);
        }

        setActiveTab(tab);
    });
};

const watchHash = () => {

    $(window).on('hashchange', function(e) {

        const { tab } = parseHashRoute(window.location.hash);

        setActiveTab(tab);
    });
};

const initialize = () => {

    watchHash();

    initializeTabs();

    $(window).on(
        'resize:horizontally',
        throttle(
            () => {
                positionTabIndicator(false);
            },
            50
        )
    );
};

export default {
    initialize,
};

